(function () {
  function getNav(itemOrPanel) {
    return itemOrPanel ? itemOrPanel.closest('.cp-dnav') : null;
  }

  function isPrimaryPointerActivation(event) {
    return event &&
      event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey;
  }

  function followLink(link) {
    if (!link || !link.href) return;
    if (link.target === '_blank') {
      window.open(link.href, '_blank', 'noopener');
      return;
    }
    window.location.assign(link.href);
  }

  function closeAll(nav) {
    if (!nav) return;
    nav.querySelectorAll('.cp-dnav__item.cp-is-open').forEach(function (item) {
      item.classList.remove('cp-is-open');
    });
    nav.querySelectorAll('.cp-dnav__panel--mega').forEach(function (panel) {
      setActive(panel, '');
    });
  }

  function setActive(panel, groupName) {
    var triggers = panel.querySelectorAll('[data-group-trigger]');
    var level3Panels = panel.querySelectorAll('[data-group-panel]');
    var leftFeatureCards = panel.querySelectorAll('[data-left-feature-card]');
    var rightFeatureCards = panel.querySelectorAll('[data-right-feature-card]');
    var leftFeatureWrap = panel.querySelector('.cp-dnav__left-feature-wrap');
    var rightFeatureWrap = panel.querySelector('.cp-dnav__right-feature-wrap');
    var shell = panel.querySelector('.cp-dnav__shell');
    var secondary = panel.querySelector('.cp-dnav__secondary');
    var currentTrigger = panel.querySelector('[data-group-trigger="' + groupName + '"]');
    var hasChildren = currentTrigger && currentTrigger.getAttribute('data-has-children') === 'true';
    var leftFeatureKey = currentTrigger ? (currentTrigger.getAttribute('data-left-feature') || '') : '';
    var rightFeatureKey = currentTrigger ? (currentTrigger.getAttribute('data-right-feature') || '') : '';

    triggers.forEach(function (trigger) {
      trigger.classList.toggle('is-active', trigger.getAttribute('data-group-trigger') === groupName);
    });

    level3Panels.forEach(function (level3) {
      var shouldShow = hasChildren && level3.getAttribute('data-group-panel') === groupName;
      level3.classList.toggle('is-active', shouldShow);
    });

    leftFeatureCards.forEach(function (feature) {
      feature.classList.toggle('is-active', leftFeatureKey !== '' && feature.getAttribute('data-left-feature-card') === leftFeatureKey);
    });

    rightFeatureCards.forEach(function (feature) {
      feature.classList.toggle('is-active', hasChildren && rightFeatureKey !== '' && feature.getAttribute('data-right-feature-card') === rightFeatureKey);
    });

    if (leftFeatureWrap) {
      leftFeatureWrap.classList.toggle('is-visible', leftFeatureKey !== '');
    }
    if (rightFeatureWrap) {
      rightFeatureWrap.classList.toggle('is-hidden', !hasChildren || rightFeatureKey === '');
    }
    if (shell) {
      shell.classList.toggle('is-no-secondary', !hasChildren);
    }
    if (secondary) {
      secondary.classList.toggle('is-hidden', !hasChildren);
    }
    if (panel.classList.contains('cp-dnav__panel--mega')) {
      panel.classList.toggle('is-collapsed', !hasChildren);
    }

  }

  function closePanel(item, panel) {
    item.classList.remove('cp-is-open');
    if (panel.classList.contains('cp-dnav__panel--mega')) {
      setActive(panel, '');
    }
  }

  function initMegaPanel(panel) {
    var triggers = panel.querySelectorAll('[data-group-trigger]');
    var secondary = panel.querySelector('.cp-dnav__secondary');
    if (!triggers.length) return;

    setActive(panel, '');

    if (secondary) {
      // The active submenu can collapse between pointerdown and click in the theme header stack.
      // Commit plain left-click navigation from the stable pointerdown target.
      secondary.addEventListener('pointerdown', function (event) {
        var link;

        if (!window.matchMedia('(min-width: 1025px)').matches) return;
        if (event.pointerType === 'touch') return;
        if (!isPrimaryPointerActivation(event)) return;

        link = event.target.closest('a[href]');
        if (!link || !secondary.contains(link)) return;
        if (link.matches('[data-action-quickshop]')) return;

        event.preventDefault();
        followLink(link);
      }, true);
    }

    triggers.forEach(function (trigger) {
      var groupName = trigger.getAttribute('data-group-trigger');
      if (!groupName) return;

      trigger.addEventListener('mouseenter', function () {
        setActive(panel, groupName);
      });
      trigger.addEventListener('focus', function () {
        setActive(panel, groupName);
      });
    });

    var item = panel.closest('.cp-dnav__item');
    if (item) {
      item.addEventListener('mouseenter', function () {
        var nav = getNav(item);
        closeAll(nav);
        item.classList.add('cp-is-open');
        setActive(panel, '');
      });

      item.addEventListener('mouseleave', function () {
        closePanel(item, panel);
      });

      item.addEventListener('focusin', function () {
        var nav = getNav(item);
        closeAll(nav);
        item.classList.add('cp-is-open');
      });

      item.addEventListener('focusout', function (event) {
        var next = event.relatedTarget;
        if (!next || !item.contains(next)) {
          closePanel(item, panel);
        }
      });

      panel.addEventListener('mouseleave', function () {
        closePanel(item, panel);
      });
    }
  }

  function initSimplePanel(panel) {
    var item = panel.closest('.cp-dnav__item');
    if (!item) return;

    item.addEventListener('mouseenter', function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add('cp-is-open');
    });

    item.addEventListener('mouseleave', function () {
      closePanel(item, panel);
    });

    item.addEventListener('focusin', function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add('cp-is-open');
    });

    item.addEventListener('focusout', function (event) {
      var next = event.relatedTarget;
      if (!next || !item.contains(next)) {
        closePanel(item, panel);
      }
    });

    panel.addEventListener('mouseleave', function () {
      closePanel(item, panel);
    });
  }

  function init() {
    var nav = document.querySelector('.cp-dnav');
    if (!nav) return;

    // Reset any stale state potentially applied by other theme scripts/classes.
    closeAll(nav);
    nav.querySelectorAll('.cp-dnav__item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
    });

    nav.querySelectorAll('.cp-dnav__panel--mega').forEach(initMegaPanel);
    nav.querySelectorAll('.cp-dnav__panel:not(.cp-dnav__panel--mega)').forEach(initSimplePanel);

    nav.addEventListener('mouseleave', function () {
      closeAll(nav);
    });

    document.addEventListener('pointermove', function (event) {
      if (!nav.contains(event.target)) {
        closeAll(nav);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll(nav);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
